<template>
  <div
    class="audio-component-wraper"
    :class="{ 'modal-ui-active': modalActive }"
    :style="$store.getters.showIcons ? 'align-items: flex-end;' : ''"
  >
    <div ref="audio" class="audio" :class="[{ 'full-width-bar': !$store.getters.showIcons }]">
      <audio id="playerAudio" :style="`--plyr-color-main: ${playerColor}`" title controls crossorigin playsinline>
        <source :src="audioFile" type="audio/ogg" />
        <source :src="audioFile" type="audio/mpeg" :key="componentKey" />
        Your browser does not support the audio element.
      </audio>
      <div class="audio-title">
        <span :style="{ 'font-size': settitleFontSize() }" v-html="this.audio.item.title"></span>
      </div>
      <!-- <button id="magic-button" @click="changeAudio()">Chnage Audio</button> -->
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Plyr from 'plyr';

import { getAudioURL } from '__mainSrcDir/Utils/DB/get';
import { AUDIO_NAMES } from '__mainSrcDir/Utils/DB/configDB';
export default {
  name: 'tr-audio',
  props: [],
  data: function () {
    return {
      audioFile: '',
      titleFontSize: '',
      deafultTitleFontSize: '',
      publicPath: process.env.BASE_URL,
      componentKey: true,
      playerColor: '#00b3ff',
    };
  },
  beforeDestroy: function () {
    console.log('Destroy Plyr audio');
    window.onresize = null;
    this.$store.commit('GALLERY_DEACTIVATE');
  },
  created: function () {
    if ('audioPlayer' in this.audio && 'color' in this.audio.audioPlayer) {
      this.playerColor = this.audio.audioPlayer.color;
    }
  },
  mounted: function () {
    console.log('MOUNT AUDIO');
    this.$store.commit('PLAYER_DIMENSIONS', {
      width: this.$refs.audio.clientWidth,
      height: this.$refs.audio.clientHeight,
    });
    this.$store.commit('PLAYER_POSITION', { x: this.$refs.audio.offsetLeft, y: this.$refs.audio.offsetTop });
    window.onresize = () => {
      this.$store.commit('PLAYER_DIMENSIONS', {
        width: this.$refs.audio.clientWidth,
        height: this.$refs.audio.clientHeight,
      });
      this.$store.commit('PLAYER_POSITION', { x: this.$refs.audio.offsetLeft, y: this.$refs.audio.offsetTop });
    };
    var options = _.cloneDeep(this.audio.item);
    var that = this;
    const player = new Plyr('#playerAudio', {
      title: 'Example Title',
    });
    let name = '/static/audio/test/test.mp3';
    if (options.mp3) {
      let audioSrc = options.mp3;
      if (process.env.VUE_PWA) {
        console.log('PWA working');
        options.mp3 = require(`__staticDir/${this.$store.getters.multibookType}/${audioSrc}`);
        console.log('options', options);
        this.changeAudio(options.mp3);
      } else {
        player.source = {
          type: 'audio',
          sources: [
            {
              src: require(`__staticDir/${this.$store.getters.multibookType}/${audioSrc}`),
              type: 'audio/mp3',
            },
          ],
        };
      }
    }
  },
  methods: {
    settitleFontSize() {
      this.titleFontSize = this.audio.item.titleFontSize;
      this.deafultTitleFontSize = '';
      if (this.titleFontSize) {
        return this.titleFontSize;
      } else {
        this.deafultTitleFontSize = this.$store.getters.getMbFilmVimeoTitleSize;
        return this.deafultTitleFontSize;
      }
    },
    changeAudio(_name) {
      console.log('CLICK');
      let name = _name;
      if (!name) {
        name = _.sample(AUDIO_NAMES);
      }
      return getAudioURL(name).then((audioURL) => {
        this.audioFile = audioURL;
        this.forceRerender();
      });
    },
    forceRerender() {
      this.componentKey = !this.componentKey;
    },
  },
  computed: {
    audio() {
      return this.$store.getters.audioData;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
    MbFilmVimeoTitleSize() {
      return this.$store.getters.getMbFilmVimeoTitleSize;
    },
  },
};
</script>

<style lang="scss">
.audio-component-wraper {
  position: absolute;
  pointer-events: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-bottom: 20px;
  .audio {
    display: block;
    width: 955px;
    height: auto;
    background-color: #ffffff;
    // background-color: #e6e6e6;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 100px;
    box-shadow: inset 0 0px 2px 1px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    // position: relative;
    #playerAudio {
      width: 100%;
    }
    .audio-title {
      padding-top: 1vmin;
      padding-bottom: 1vmin;
      font-size: 2vmin;
    }
  }
  .full-width-bar {
    padding-right: 20px;
  }
}
#magic-button {
  pointer-events: auto;
}
/**change base white color to light grey */
.plyr--audio .plyr__controls {
  background: #e6e6e6 !important;
}
.plyr__menu__container {
  background: rgba(#e6e6e6, 0.9);
}
</style>
